import angular from 'angular';

import { endOfFilter, formatFilter, fromNowFilter } from './moment.filter';
import { momentProvider } from './moment.provider';

export default angular
  .module('moment', [])
  .filter('fromNow', fromNowFilter)
  .filter('format', formatFilter)
  .filter('endOf', endOfFilter)
  .provider('moment', momentProvider);
